import React, { useState } from 'react';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { CountryDropdown } from 'react-country-region-selector';
import { Link } from 'react-router-dom';
import './index.css';
import { db } from '../../firebaseConfig';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { toast } from "react-hot-toast";

const RegistrationForm = () => {
  const [formData, setFormData] = useState({
    name: '', email: '', phoneNumber: '', country: 'India', interests: '', investorType: [], termsAccepted: false
  });
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === 'checkbox' && name === 'investorType') {
      setFormData(prev => ({ ...prev, investorType: checked ? [...prev.investorType, value] : prev.investorType.filter(t => t !== value) }));
    } else {
      setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    }
  };

  const handlePhoneChange = (value) => setFormData(prev => ({ ...prev, phoneNumber: value }));
  const handleCountryChange = (value) => setFormData(prev => ({ ...prev, country: value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, email, phoneNumber, country, interests, investorType, termsAccepted } = formData;
    try {
      const userData = { name, email, phoneNumber, country, interests, investorType, termsAccepted };

      // Save to Firestore + send emails via backend API
      await Promise.all([
        addDoc(collection(db, 'luxeunbounded'), {
          ...userData,
          timestamp: serverTimestamp()
        }),
        fetch('https://luxe-backend.netlify.app/luxe-form-submit', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(userData),
        })
      ]);

      setFormData({ name: '', email: '', phoneNumber: '', country: 'India', interests: '', investorType: [], termsAccepted: false });
      setSubmitStatus('success');
      toast.success("Registration Successful");
    } catch (error) {
      setSubmitStatus('error');
      toast.error(`Error: ${error.message}`);
    }
  };

  return (
    <>
      <div className="reg-section">
        <div className="reg-header-wrap">
          <p className="reg-label-top">Join The Club</p>
          <h2 className="reg-main-title">Express Your Interest</h2>
          <p className="reg-main-sub">Complete the form below to receive our introductory Club Membership Guide and learn more about the benefits of joining Luxe Unbounded.</p>
        </div>
        <div className="reg-form-wrap">
          <form className="reg-form" onSubmit={handleSubmit}>
            <div className="reg-row">
              <div className="reg-field">
                <label className="reg-label">Full Name *</label>
                <input type="text" className="reg-input" placeholder="Your full name" name="name" value={formData.name} onChange={handleInputChange} required />
              </div>
              <div className="reg-field">
                <label className="reg-label">Email Address *</label>
                <input type="email" className="reg-input" placeholder="your@email.com" name="email" value={formData.email} onChange={handleInputChange} required />
              </div>
            </div>
            <div className="reg-row">
              <div className="reg-field">
                <label className="reg-label">Country *</label>
                <CountryDropdown value={formData.country} onChange={handleCountryChange} classes="reg-select" defaultOptionLabel="Select country" name="country" required />
              </div>
              <div className="reg-field">
                <label className="reg-label">Phone Number *</label>
                <PhoneInput international defaultCountry="IN" value={formData.phoneNumber} onChange={handlePhoneChange} className="reg-input reg-phone" placeholder="Phone number" required />
              </div>
            </div>
            <div className="reg-field reg-field--full">
              <label className="reg-label">What are you interested in?</label>
              <textarea className="reg-textarea" rows="3" placeholder="Tell us what you'd like to learn more about..." name="interests" value={formData.interests} onChange={handleInputChange} />
            </div>
            <hr className="reg-divider" />
            <span className="reg-checks-label">I am (select all that apply)</span>
            <div className="reg-checks">
              <label className="reg-check-item">
                <input type="checkbox" name="investorType" value="highNetWorth" onChange={handleInputChange} checked={formData.investorType.includes('highNetWorth')} />
                <span>A High Net Worth Individual</span>
              </label>
              <label className="reg-check-item">
                <input type="checkbox" name="investorType" value="sophisticatedInvestor" onChange={handleInputChange} checked={formData.investorType.includes('sophisticatedInvestor')} />
                <span>A Sophisticated Investor</span>
              </label>
              <label className="reg-check-item">
                <input type="checkbox" name="investorType" value="partnerProperty" onChange={handleInputChange} checked={formData.investorType.includes('partnerProperty')} />
                <span>Interested in the Partner Property Model</span>
              </label>
              <label className="reg-check-item">
                <input type="checkbox" name="investorType" value="investAamaya" onChange={handleInputChange} checked={formData.investorType.includes('investAamaya')} />
                <span>Interested in Investing in Amaya</span>
              </label>
            </div>
            <div className="reg-note">You will be subscribed to The Club's communications with updates on activities, offers, and announcements.</div>
            <label className="reg-terms">
              <input type="checkbox" name="termsAccepted" checked={formData.termsAccepted} onChange={handleInputChange} required />
              <span>Yes, I agree to the <Link to="/terms-conditions">Terms &amp; Conditions</Link> and <Link to="/privacy-policy">Privacy Policy</Link> and consent to receive communications from The Club.</span>
            </label>
            <button type="submit" className="reg-submit">Submit Expression of Interest</button>
            {submitStatus === 'success' && <p className="reg-success">Registration successful! We'll be in touch shortly.</p>}
            {submitStatus === 'error' && <p className="reg-error">Something went wrong. Please try again.</p>}
          </form>
        </div>
      </div>
    </>
  );
};

export default RegistrationForm;
